var _style, _defs, _g, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgBttomLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 940.8 428.8",
    style: {
      enableBackground: "new 0 0 940.8 428.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.13;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#194581;}\n\t.st3{clip-path:url(#SVGID_4_);fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 940.8,
    height: 428.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M940.2,428.8c0,0,12.1-93.5-79.7-144s-200.6,6.1-257.3,34.5s-130.4,65.1-142.6-13s21.5-213.7-65-275.7 S188.8,19,96.9,26.7S0,12.1,0,12.1v415.8L940.2,428.8z"
  }))))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    y: 0,
    width: 940.2,
    height: 428.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-66.4,218.1c0,0,143.4-82.2,297-45.9c153.6,36.3,67.6,222.9,106,301.9c38.4,79,64.3,80.6,64.3,80.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-64.5,231.4c0,0,135.6-79.7,280.7-45c9.5,2.3,18.1,5.2,25.7,8.6c109.1,48.8,41.3,207.4,74.7,277.8 c35.8,74.6,59.8,76.7,59.8,76.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-62.6,244.8c0,0,127.8-77.1,264.4-44c9,2.2,17,4.9,24.3,8.2c102.5,46.2,39.3,195.9,70.5,262.6 c32.9,70.4,55.4,72.9,55.4,72.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-60.7,258.1c0,0,120.1-74.5,248.1-43c8.4,2.1,16,4.7,22.8,7.9c95.8,43.9,37.6,184.2,66.4,247.4 c30.1,66,50.9,69,50.9,69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-58.7,271.5c0,0,112.3-71.9,231.9-42.1c7.8,2,14.9,4.5,21.4,7.5c89.2,41.5,35.8,172.6,62.2,232.2 c27.4,61.7,46.4,65.1,46.4,65.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-56.8,284.8c0,0,104.6-69.3,215.6-41.1c7.3,1.9,13.9,4.3,19.9,7.1c82.6,39,34,161,58.1,217 c24.6,57.3,41.9,61.3,41.9,61.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-54.9,298.2c0,0,96.8-66.8,199.3-40.1c6.7,1.8,12.9,4,18.4,6.7c76,36.5,32.2,149.3,53.9,201.8 c21.9,53,37.4,57.4,37.4,57.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-53,311.5c0,0,89-64.2,183-39.1c6.2,1.7,11.8,3.8,17,6.3c69.4,34,30.5,137.7,49.8,186.6 c19.2,48.6,32.9,53.6,32.9,53.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-51.1,324.9c0,0,81.3-61.6,166.8-38.2c5.6,1.6,10.8,3.6,15.5,6c62.8,31.5,28.7,126,45.6,171.5 c16.5,44.2,28.4,49.7,28.4,49.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-49.1,338.3c0,0,73.5-59,150.5-37.2c5.1,1.4,9.7,3.3,14,5.6c56.2,29,27,114.3,41.5,156.3 c13.8,39.8,24,45.8,24,45.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-47.2,351.6c0,0,65.8-56.4,134.2-36.2c4.5,1.3,8.7,3.1,12.6,5.2c49.6,26.5,25.3,102.6,37.3,141.1 c11.1,35.4,19.5,42,19.5,42"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-45.3,365c0,0,58-53.9,118-35.3c4,1.2,7.7,2.9,11.1,4.8c43,24,23.6,90.9,33.2,125.9c8.5,31,15,38.1,15,38.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-43.4,378.3c0,0,50.2-51.3,101.7-34.3c3.4,1.1,6.6,2.6,9.7,4.4c36.5,21.4,21.9,79.2,29,110.7 c6,26.5,10.5,34.3,10.5,34.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-41.5,391.7c0,0,42.5-48.7,85.4-33.3c2.9,1,5.6,2.4,8.2,4c29.9,18.8,20.4,67.4,24.9,95.5 c3.5,22,6,30.4,6,30.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-39.5,405c0,0,34.7-46.1,69.1-32.4c2.3,0.9,4.5,2.2,6.7,3.7c23.4,16.1,19.1,55.6,20.7,80.3 c1.2,17.5,1.5,26.5,1.5,26.5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-37.6,418.4c0,0,30.7-49.7,58.1-28.1c27.4,21.6,13.6,87.8,13.6,87.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBttomLeft);
export default __webpack_public_path__ + "static/media/bg-bttom-left.aeaf2d7d258cc0c504a1c37db7e5bc8f.svg";
export { ForwardRef as ReactComponent };